<app-pagetoolbar [label]="'Historical Participants'" [icon]="'history'"></app-pagetoolbar>

<div class="filters-container">
  <!-- Search Bar -->
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Search</mat-label>
    <input matInput [formControl]="searchControl" placeholder="Search by ENIS, name, center or reason" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <!-- Transplanted Filter -->
  <mat-button-toggle-group
    [value]="transplantedFilter"
    (change)="onTransplantedFilterChange($event.value)"
    class="filter-group">
    <mat-button-toggle value="all">All</mat-button-toggle>
    <mat-button-toggle value="transplanted">Transplanted</mat-button-toggle>
    <mat-button-toggle value="not-transplanted">Not Transplanted</mat-button-toggle>
  </mat-button-toggle-group>

  <!-- Participant Type Filter (no Pairs) -->
  <mat-button-toggle-group
    [value]="participantType"
    (change)="onParticipantTypeChange($event.value)"
    class="filter-group">
    <mat-button-toggle value="all">All</mat-button-toggle>
    <mat-button-toggle value="recipients">Recipients</mat-button-toggle>
    <mat-button-toggle value="donors">Donors</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<div class="results-summary">
  <p>Total: {{ filteredParticipants.length }} historical participants</p>
</div>

<div class="participants-container">
  <mat-expansion-panel
    *ngFor="let participant of filteredParticipants"
    [id]="'hist-' + participant.enisNumber"
    (opened)="onPanelOpened(participant)">
    <mat-expansion-panel-header class="historical-header">
      <mat-panel-title>
        <div class="historical-row">
          <span class="col-type">{{ typeLabel(participant) }}</span>
          <b class="col-enis">{{ participant.enisNumber }}</b>
          <span class="col-name">{{ participant.firstName }} {{ participant.lastName }}</span>
          <span class="col-center">{{ participant.center?.name }}</span>
          <span class="col-reason">
            <span class="historical-badge" [class.transplanted]="isTransplantedReason(participant.historicalReason)">
              {{ participant.historicalReason || '—' }}
            </span>
          </span>
          <span class="col-date">Archived on {{ participant.historicalDate | date: 'dd-MM-yyyy' }}</span>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="historical-detail">
      <!-- Left: full participant detail -->
      <div class="historical-detail-main">
        <app-participant-box
          *ngIf="participant.type === 'Recipient'"
          [recipient]="asRecipient(participant)"
          [history]="true">
        </app-participant-box>
        <app-participant-box
          *ngIf="participant.type === 'Donor'"
          [donor]="asDonor(participant)"
          [history]="true">
        </app-participant-box>
      </div>

      <!-- Right: relationship info blocks -->
      <div class="historical-relations">
        <ng-container *ngIf="relationsLoading[participant.enisNumber]">
          <div class="relations-loading">
            <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
            <span>Loading relations…</span>
          </div>
        </ng-container>

        <ng-container *ngIf="relationsByEnis[participant.enisNumber] as relations">
          <!-- Was a pair with -->
          <div class="relation-block">
            <h4>Was a pair with</h4>
            <p *ngIf="relations.pairedWith.length === 0" class="relation-empty">No one</p>
            <ng-container *ngFor="let partner of relations.pairedWith">
              <ng-container *ngTemplateOutlet="partnerLine; context: { $implicit: partner }"></ng-container>
            </ng-container>
          </div>

          <!-- Was matched and transplanted with -->
          <div class="relation-block">
            <h4>Was matched and transplanted with</h4>
            <p *ngIf="!relations.transplantedWith" class="relation-empty">No one</p>
            <ng-container *ngIf="relations.transplantedWith as partner">
              <ng-container *ngTemplateOutlet="partnerLine; context: { $implicit: partner }"></ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-expansion-panel>

  <!-- Empty State -->
  <div *ngIf="filteredParticipants.length === 0" class="empty-state">
    <mat-icon>history</mat-icon>
    <p>No historical participants found</p>
  </div>
</div>

<!-- Renders a single partner line. Links to the partner's card on this page when it is present
     in the list and the current user is allowed to open it. -->
<ng-template #partnerLine let-partner>
  <p class="relation-partner">
    <a
      *ngIf="partner.canLink && isInHistoricalList(partner.enisNumber); else plainPartner"
      class="partner-link"
      (click)="goToPartnerCard(partner)">
      {{ partner.type | titlecase }} {{ partner.enisNumber }}<span *ngIf="partner.centerCode">-{{ partner.centerCode }}</span>
    </a>
    <ng-template #plainPartner>
      {{ partner.type | titlecase }} {{ partner.enisNumber }}<span *ngIf="partner.centerCode">-{{ partner.centerCode }}</span>
    </ng-template>
  </p>
</ng-template>
